import React from 'react';
import PropTypes from 'prop-types';

export const ReportSchedules = ({ width , height , ...props }) => (
  <svg
    data-icon='report-schedules'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m18.5 19.5 1-.5-2-2.5V14h-1v3l2 2.5ZM7 14h3.675c.183-.383.396-.742.637-1.075.242-.333.513-.642.813-.925H7v2Zm0 4h3.075a6.732 6.732 0 0 1 0-2H7v2Zm-2 4c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 2h8l6 6v2.3a6.373 6.373 0 0 0-.975-.225A6.901 6.901 0 0 0 17 10V9h-5V4H5v16h5.675c.183.383.396.742.637 1.075.242.333.513.642.813.925H5Zm12-10c1.383 0 2.563.488 3.538 1.463C21.512 14.438 22 15.617 22 17s-.488 2.563-1.462 3.538C19.562 21.512 18.383 22 17 22s-2.563-.488-3.537-1.462C12.488 19.562 12 18.383 12 17s.488-2.563 1.463-3.537C14.438 12.488 15.617 12 17 12Z'
    />
  </svg>
);

ReportSchedules.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ReportSchedules.defaultProps = {
  width: 24,
  height: 24,
};
